import React, { Component } from "react";
import TranslatedPage from "../TranslatedPage";
import { connect } from "react-redux";
import { Button, Icon, Dialog } from "@blueprintjs/core";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { Translate } from "react-redux-i18n";

import "./CustomBanners.scss";
import NewGiftDecorator from "../NewGiftDecorator/NewGiftDecorator";

class LandingWhiteMonday extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show_video_explainer: false
    };
  }
  toggleVideoExplainer = () => {
    this.setState({ show_video_explainer: !this.state.show_video_explainer });
  };
  render() {
    return (
      <section className="hero image-hero white-monday">
        <div className="puzzle-piece-01" />
        <div className="puzzle-piece-02" />
        <div className="puzzle-piece-03" />
        <div className="main-container">
          <div className="main-hero-copy">
            <span className="hashtag-copy"></span>
            <h1 className="bp3-heading">
              <TranslatedPage path="whitemonday.content_blocks.hero_whitemonday.heading" />
            </h1>
            <h2 className="bp3-heading light opacity90">
              <TranslatedPage path="whitemonday.content_blocks.hero_whitemonday.content" />
            </h2>
            <div className="cta-area">
              <NewGiftDecorator>
                <Button className="main-cta button" intent="primary">
                  <Translate value="whitemonday.landing_whitemonday.create_gift" />
                </Button>
              </NewGiftDecorator>
              <AnchorLink href="#how-it-works" className="secondary-cta">
                <Translate value="whitemonday.landing_whitemonday.learn_more" />
              </AnchorLink>
            </div>
          </div>
          <div className="video-explainer" onClick={this.toggleVideoExplainer}>
            <div className="play-icon">
              <Icon icon="play" iconSize="48" />
            </div>
          </div>
          <Dialog
            title={<TranslatedPage path="whitemonday.content_blocks.whitemonday_how_it_works_header.heading" />}
            autoFocus="true"
            isOpen={this.state.show_video_explainer}
            onClose={this.toggleVideoExplainer}
            className="video-modal">
            <div className="dialog-body">
              <div className="video-container">
                <iframe
                  title="#whitemonday"
                  className="video-item"
                  src="https://www.youtube.com/embed/UoaSnNQGkOg?autoplay=1"
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen></iframe>
              </div>
            </div>
          </Dialog>
        </div>
      </section>
    );
  }
}
const mapStateToProps = state => ({
  locale: state.i18n.locale
});
const mapDispatchToProps = dispatch => ({});
export default connect(mapStateToProps, mapDispatchToProps)(LandingWhiteMonday);
